import { BrandModel } from "./BrandModel";
import { StoreModel } from "./StoreModel";
import { ImageModel } from "./ImageModel";

export interface PricingStore {
	createdAt: string;
	discountedPrice: number;
	finalActualPrice: number;
	finalDiscountedPrice: number;
	jewelleryPrice: number;
	id: string;
	isActive: boolean;
	pricing: Pricing;
	updatedAt: string;
	va: number;
	vaDiscount: number;
	wastageCharge: number;
	wastageChargeDiscount: number;
	totalMakingCharge: number;
	totalDiamondCost: number;
	totalDiamondDiscount: number;
	totalMakingChargeDiscount: number;
	totalMetalCost: number;
	totalStoneCost: number;
	totalStoneDiscount: number;
	defaultCoupons: DefaultCoupons[]
}

export interface DefaultCoupons {
	code: string,
	name: string,
	discount: {
		discountType: string,
		discountValue: number,
		maxDiscountAmount: number,
		minPurchaseAmount: number
	},
	expiration: Date,
	offerAmount: number
}

export interface IItem {
	premiumCustomersOnly: boolean;
	name: string;
	uniqueName: string;
	images: [{
		ITEM_DETAIL: ImageModel;
		ITEM_DETAIL_THUMBNAIL: ImageModel;
		ITEM_LISTING: ImageModel;
		original: ImageModel;
		showOnListing: boolean
	}];
	gender: string;
	itemType: ItemType;
	productType: ProductType;
	productTypeRange?: ProductTypeRange;
	collectionTypes: CollectionType[];
	occasions: OccasionType[];
	bestForGift: boolean;
	createdAt: string;
	updatedAt: number;
	id: string;
	brand: BrandModel;
	likes: any[];
	review: any[];
	description?: string;
	// isWholesaleItem: boolean;
	isB2B: boolean;
	isActive: boolean;
	itemCode: string;
	itemVariations: ItemVariation[];
	discountedPrice: number,
	price: number
}

export interface ItemVariation {
	createdAt: string;
	diamond?: IDiamond[];
	forKids: boolean;
	height: number;
	huid?: any[];
	id: string;
	itemGrossWeight: number;
	pricingDefault: Pricing;
	pricingPerStore: [{
		store: StoreModel;
		pricing: PricingStore
	}];
	primaryMetal: IMetal;
	secondaryMetal?: IMetal;
	size: number;
	stones?: IStone[];
	updatedAt: string;
	width: number;
	inventory: {
		quantity: number;
		reserveQuantity: number
	}
}

export interface ItemType {
	name: string;
	createdAt: string;
	updatedAt: string;
	id: string;
}

export interface ProductType {
	name: string;
	createdAt: string;
	updatedAt: string;
	id: string;
}

export interface ProductTypeRange {
	name: string;
	createdAt: string;
	updatedAt: string;
	id: string;
}

export interface CollectionType {
	name: string;
	createdAt: string;
	updatedAt: string;
	id: string;
}

export interface OccasionType {
	name: string;
	createdAt: string;
	updatedAt: string;
	id: string;
}

export interface IDiamond {
	name: string;
	count: number;
	weight: number;
	price: number;
	discount: number;
	clarity: string;
	shape: string;
	color: string;
	quality: string;
	_id: string;
}

export interface IMetal {
	metal?: string;
	color: string;
	name: string;
	purity: string;
	weight: number;
	_id: string
}

export interface IStone {
	name: string;
	count: number;
	weight: number;
	price: number;
	discount: number;
	_id: string
}

export interface Pricing {
	price: number;
	discount: number;
	makingCharge: number;
	makingChargeDiscount: number;
	isActive: boolean;
	id: string;
	createdAt?: string;
	updatedAt?: string;
	fixRate: number
	wastage: number;
	va: number;
};

export const ITEM_GENDER = [
	{ value: 'Women', label: 'Women' },
	{ value: 'Men', label: 'Men' },
	{ value: 'Kids', label: 'Kids' },
	{ value: 'UniSex', label: 'Unisex' }
];

export const ITEM_METALS = [
	{ value: '', label: 'PLEASE SELECT' },
	{ value: 'GOLD', label: 'Gold' },
	{ value: 'SILVER', label: 'Silver' },
	{ value: 'PLATINUM', label: 'Platinum' },
];
export const ITEM_METALS_COLORS = {
	GOLD: [
		{ value: '', label: 'PLEASE SELECT' },
		{ value: 'GOLD', label: 'Gold' },
		{ value: 'YELLOW', label: 'Yellow' },
	]
};
export const ITEM_METALS_PURITY = {
	GOLD: [
		{ value: '', label: 'PLEASE SELECT' },
		{ value: 'GOLD_10', label: '10 Caret' },
		{ value: 'GOLD_14', label: '14 Caret' },
		{ value: 'GOLD_18', label: '18 Caret' },
		{ value: 'GOLD_22', label: '22 Caret' },
		{ value: 'GOLD_24', label: '24 Caret' },
	]
};

// export function doCalculateItemPrice(item: IItem) {
// 	try {
// 		const finalDiscountedPrice = item?.pricingPerStore[0].pricing.finalDiscountedPrice || 0;
// 		const finalActualPrice = item?.pricingPerStore[0].pricing.finalActualPrice || 0;

// 		return [finalActualPrice, finalDiscountedPrice];
// 	} catch (e) {
// 		return [0,0];
// 		console.error(e);
// 	}
// }

// export function doCalculateItemPrice(variations: ItemVariation[]): [number, number, any] {
// 	try {
// 		if (!variations.length) {
// 			throw 'variation length error';
// 		}

// 		let finalDiscountedPrice: number = 0;
// 		let finalActualPrice: number = 0;
// 		let selectedVariation: ItemVariation | null = null;

// 		variations.forEach(variation => {
// 			if (finalDiscountedPrice != 0) {
// 				if (variation?.pricingPerStore[0]?.pricing?.finalDiscountedPrice < finalDiscountedPrice) {
// 					selectedVariation = variation;
// 					finalDiscountedPrice = variation?.pricingPerStore[0]?.pricing?.finalDiscountedPrice;
// 					finalActualPrice = variation?.pricingPerStore[0]?.pricing?.finalActualPrice;
// 				}
// 			} else {
// 				selectedVariation = variation;
// 				finalDiscountedPrice = variation?.pricingPerStore[0].pricing?.finalDiscountedPrice;
// 				finalActualPrice = variation?.pricingPerStore[0].pricing?.finalActualPrice;
// 			}
// 		});

// 		return [finalActualPrice, finalDiscountedPrice, selectedVariation];
// 	} catch (e) {
// 		console.error(e);
// 		return [0, 0, null];
// 	}
// }

export function doCalculateItemPrice(variations: ItemVariation[], storeId?: any): [number, number, any] {
	try {
		if (!variations.length) {
			throw 'variation length error';
		}

		let finalDiscountedPrice: number | null = null;
		let finalActualPrice: number | null = null;
		let selectedVariation: ItemVariation | null = null;

		variations.forEach(variation => {
			variation?.pricingPerStore.forEach((pricing: any) => {
				if (storeId && storeId == pricing?.store?.id) {
					if (finalDiscountedPrice === null || pricing?.pricing?.finalDiscountedPrice < finalDiscountedPrice) {
						selectedVariation = variation;
						finalDiscountedPrice = pricing?.pricing?.finalDiscountedPrice;
						finalActualPrice = pricing?.pricing?.finalActualPrice;
					}
				} else if (!storeId) {
					// No storeId provided, use the first available price
					if (finalDiscountedPrice === null || variation?.pricingPerStore[0]?.pricing?.finalDiscountedPrice < finalDiscountedPrice) {
						selectedVariation = variation;
						finalDiscountedPrice = variation?.pricingPerStore[0]?.pricing?.finalDiscountedPrice;
						finalActualPrice = variation?.pricingPerStore[0]?.pricing?.finalActualPrice;
					}
				}
			});
		});

		// If no store-specific pricing was found, fall back to the first available price
		if (finalDiscountedPrice === null && variations.length > 0) {
			selectedVariation = variations[0];
			finalDiscountedPrice = variations[0]?.pricingPerStore[0]?.pricing?.finalDiscountedPrice;
			finalActualPrice = variations[0]?.pricingPerStore[0]?.pricing?.finalActualPrice;
		}

		return [finalActualPrice ?? 0, finalDiscountedPrice ?? 0, selectedVariation];
	} catch (e) {
		console.error(e);
		return [0, 0, null];
	}
}
